import React, { useContext } from "react";
import { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import "./Header.css";
import Logo from "../../assets/images/home/headerLogo4k.png";
import PointsImg from "../../assets/images/home/points.png";
import RequestImg from "../../assets/images/home/request.png";
import ProfileImg from "../../assets/images/placeholder-image.jpg";
import { MdGTranslate } from "react-icons/md";
import { IoIosLogOut } from "react-icons/io";
import Dropdown from "react-bootstrap/Dropdown";
import "./Header.css";
import { MdOutlineDashboard } from "react-icons/md";
import { RiMenu2Fill } from "react-icons/ri";
import { FaRegEdit } from "react-icons/fa";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { axiosInstance } from "../../axiosInstance";
import { LanguageContext } from "../LanguageContext";
import translations from "./translation.json";
import { CgProfile } from "react-icons/cg";
import { RiContactsBookLine } from "react-icons/ri";
import { NavbarText } from "react-bootstrap";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "90%",
    sm: 400,
    md: 500,
  },
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "10px",
  p: 4,
};

export function Header() {
  const location = useLocation();
  const pathName = location.pathname;
  const { language, setLanguage } = useContext(LanguageContext);
  const [matchmakerName, setMatchMakerName] = useState([]);
  const [usertype, setUserType] = useState([]);
  const [matchmakerImg, setmatchmakerImg] = useState();
  // const [activeMenu, setActiveMenu] = useState(
  //   localStorage.getItem("activeMenu") || "dashboard"
  // );
  const [activeMenu, setActiveMenu] = useState(pathName || "/");
  useEffect(() => {
    setActiveMenu(pathName);
  }, [pathName]);
  // modal state
  const [open, setOpen] = React.useState(false);
  const handlemodalOpen = () => setOpen(true);
  const handlemodalClose = () => setOpen(false);
  // Add state to control offcanvas visibility
  const [show, setShow] = useState(false);

  // Handlers for closing and toggling the sidebar
  const handleClose = () => setShow(false);
  const handleToggle = () => setShow(!show);
  // show header only when having token
  const token = localStorage.getItem("token");

  const navigate = useNavigate();
  function handleLogout() {
    localStorage.removeItem("phoneNumber");
    localStorage.removeItem("token");
    // localStorage.removeItem("matchmaker_name");
    // localStorage.removeItem("matchmaker_id");
    // localStorage.removeItem("matchmaker_email");
    // localStorage.removeItem("matchmaker_fullname");
    localStorage.removeItem("language");
    // localStorage.removeItem("activePlan");
    // localStorage.removeItem("matchmaker_agencyname");
    localStorage.removeItem("PlanType");
    localStorage.removeItem("public_token");
    localStorage.removeItem("activeMenu");
    navigate("/");
  }
  async function LoadMatchmaker() {
    try {
      const response = await axiosInstance.get("profile");
      const matchmakerData = response.data.data;
      setMatchMakerName(matchmakerData.first_name);
      const userPlan =
        matchmakerData.plan === "Recommended"
          ? "Standard"
          : matchmakerData.plan;

      setUserType(userPlan);
      localStorage.setItem("PlanType", matchmakerData.plan);

      setmatchmakerImg(matchmakerData.profile_pic);
      console.log("profileurl", matchmakerData.data.profile_pic);
      // localStorage.setItem("matchmaker_name", matchmakerData.first_name);
      // localStorage.setItem("matchmaker_id", matchmakerData.id);
      // localStorage.setItem("matchmaker_email", matchmakerData.email);
      // localStorage.setItem("matchmaker_fullname", matchmakerData.full_name);
      // localStorage.setItem("matchmaker_agencyname", matchmakerData.agency_name);
    } catch (error) {
      console.error("Error fetching user details", error);
    }
  }
  useEffect(() => {
    LoadMatchmaker();
  }, []);

  return (
    <>
      {token ? (
        <Navbar expand="lg" className="navBar" sticky="top">
          <Container>
            <Navbar.Toggle
              aria-controls="offcanvasNavbar-expand-lg"
              onClick={handleToggle}
            />
            <Dropdown className="navDropdown mobileTraslateDrop">
              <Dropdown.Toggle
                id="dropdown-basic"
                className="mobileTraslateDropToggle"
              >
                {language === "en" ? "English" : "తెలుగు"}
              </Dropdown.Toggle>

              <Dropdown.Menu className="mobileTraslateDropMenu">
                <Dropdown.Item onClick={() => setLanguage("en")}>
                  English
                </Dropdown.Item>
                <Dropdown.Item onClick={() => setLanguage("te")}>
                  Telugu
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <Navbar.Brand href="/home" className="brandLogo">
              <img src={Logo} alt="Logo" />
            </Navbar.Brand>

            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-lg`}
              aria-labelledby={`offcanvasNavbarLabel-expand-lg`}
              placement="start"
              show={show}
              onHide={handleClose}
            >
              {/* <Offcanvas.Header closeButton> */}
              <Offcanvas.Header>
                <div className="offcanvasHeader headerProfileImg">
                  <div className="me-2">
                    {" "}
                    <Link to={"/matchmaker-profile-edit"}>
                      {" "}
                      <img
                        src={matchmakerImg ? matchmakerImg : ProfileImg}
                        onClick={() => {
                          handleClose();
                          // setActiveMenu("/matchmaker-profile-edit");
                          // localStorage.setItem("activeMenu", "myprofile");
                        }}
                        className={
                          activeMenu === "/matchmaker-profile-edit"
                            ? "activeMenu"
                            : "navText"
                        }
                      />
                    </Link>
                  </div>
                  <div className="me-2">
                    <div className="profileName">{matchmakerName}</div>
                    <div className="profileDesc">{usertype}</div>
                  </div>
                  {/* <Dropdown className="navDropdown">
              <Dropdown.Toggle id="dropdown-basic">
               
                {language === 'en' ? 'English' : 'తెలుగు'} 
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item  onClick={() => setLanguage('en')}>English</Dropdown.Item>
                <Dropdown.Item onClick={() => setLanguage('te')}>Telugu</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown> */}
                </div>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="justify-content-center flex-grow-1 pe-3">
                  {/* Add onClick to close sidebar when links are clicked */}
                  <Nav.Link
                    href="/home"
                    onClick={() => {
                      handleClose();
                      // setActiveMenu("dashboard");
                      // localStorage.setItem("activeMenu", "dashboard");
                    }}
                    className={
                      activeMenu === "/home" ? "activeMenu" : "navText"
                    }
                  >
                    <span className=" fs-5">
                      {" "}
                      <MdOutlineDashboard />
                    </span>{" "}
                    {translations[language].first_menu}
                  </Nav.Link>
                  <Nav.Link
                    href="/trasactions"
                    onClick={() => {
                      handleClose();
                      // setActiveMenu("transactions");
                      // localStorage.setItem("activeMenu", "transactions");
                    }}
                    className={
                      activeMenu === "/trasactions" ? "activeMenu" : "navText"
                    }
                  >
                    <span className="fs-5">
                      <RiMenu2Fill />
                    </span>{" "}
                    {translations[language].second_menu}
                  </Nav.Link>
                  <Nav.Link
                    href="/matchmaker-profile-edit"
                    onClick={() => {
                      handleClose();
                      // setActiveMenu("myprofile");
                      // localStorage.setItem("activeMenu", "myprofile");
                    }}
                    className={
                      activeMenu === "/matchmaker-profile-edit"
                        ? "activeMenu"
                        : "navText"
                    }
                  >
                    <span className="fs-5">
                      <CgProfile />
                    </span>{" "}
                    {translations[language].third_menu}
                  </Nav.Link>
                  <Nav.Link
                    href="/contact-us"
                    onClick={() => {
                      handleClose();
                      // setActiveMenu("contactus");
                      // localStorage.setItem("activeMenu", "contactus");
                    }}
                    className={
                      activeMenu === "/contact-us" ? "activeMenu" : "navText"
                    }
                  >
                    <span className="fs-5">
                      <RiContactsBookLine />
                    </span>{" "}
                    {translations[language].fourth_menu}
                  </Nav.Link>
                </Nav>
                <Nav>
                  <Dropdown className="navDropdown profileResponsiveContainer">
                    <Dropdown.Toggle id="dropdown-basic">
                      {/* <MdGTranslate /> */}
                      {language === "en" ? "English" : "తెలుగు"}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => setLanguage("en")}>
                        English
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => setLanguage("te")}>
                        Telugu
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>

                  <div
                    className="profileResponsiveContainer"
                    style={{ display: "flex" }}
                  >
                    <div className="me-2 headerProfileImg">
                      {" "}
                      <Link to={"/matchmaker-profile-edit"}>
                        {" "}
                        <img
                          src={matchmakerImg ? matchmakerImg : ProfileImg}
                          onClick={() => {
                            handleClose();
                            // setActiveMenu("myprofile");
                            // localStorage.setItem("activeMenu", "myprofile");
                          }}
                          className={
                            activeMenu === "/matchmaker-profile-edit"
                              ? "activeMenu"
                              : "navText"
                          }
                        />
                      </Link>
                    </div>
                    <div className="me-2">
                      <div className="profileName">{matchmakerName}</div>
                      <div className="profileDesc">{usertype}</div>
                    </div>
                  </div>
                  {/* <div>

           <Button onClick={handlemodalOpen}  className="fs-4 ms-2" style={{color:'#716466'}}><IoIosLogOut /></Button>
          </div> */}
                  <div>
                    <Nav.Link
                      onClick={handlemodalOpen}
                      className="navText d-flex"
                      title="Logout"
                    >
                      <span className="fs-5">
                        <IoIosLogOut />
                      </span>{" "}
                      <span
                        className="logoutText"
                        style={{ marginLeft: "5px", marginTop: "3px" }}
                      >
                        {translations[language].logout}
                      </span>
                    </Nav.Link>
                  </div>
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
          <Modal
            open={open}
            onClose={handlemodalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography id="modal-modal-title" className="headermodalTitle">
                Logout Confirmation
              </Typography>
              <Typography
                id="modal-modal-description"
                className="headermodalDesc"
              >
                Are you sure you want to logout?
              </Typography>
              <div className="headerbtnContainer">
                <Button
                  className="headermodalCancel"
                  onClick={handlemodalClose}
                >
                  Cancel
                </Button>
                <Button className="headermodalLogout" onClick={handleLogout}>
                  Logout
                </Button>
              </div>
            </Box>
          </Modal>
        </Navbar>
      ) : (
        ""
      )}
    </>
  );
}
